var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/arrow/down"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M16.7545 5.37084C17.141 4.97625 17.7741 4.96962 18.1687 5.35603C18.5329 5.71272 18.5666 6.27963 18.2657 6.6751L18.1835 6.77017L10.7146 14.3972C10.3531 14.7663 9.77694 14.7952 9.38181 14.4836L9.28702 14.3986L1.78815 6.7716C1.40095 6.37778 1.40631 5.74464 1.80013 5.35743C2.16365 5.00002 2.7311 4.97709 3.12079 5.28543L3.21429 5.36941L9.99809 12.269L16.7545 5.37084Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 18,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 2_2",
    d: "M16.7545 5.37084C17.141 4.97625 17.7741 4.96962 18.1687 5.35603C18.5329 5.71272 18.5666 6.27963 18.2657 6.6751L18.1835 6.77017L10.7146 14.3972C10.3531 14.7663 9.77694 14.7952 9.38181 14.4836L9.28702 14.3986L1.78815 6.7716C1.40095 6.37778 1.40631 5.74464 1.80013 5.35743C2.16365 5.00002 2.7311 4.97709 3.12079 5.28543L3.21429 5.36941L9.99809 12.269L16.7545 5.37084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/ambient/sophia"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 20,
    height: 20,
    fill: "#E8703C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown1X);
export default __webpack_public_path__ + "static/media/down@1x.1f954967e3b979ff14c5204588aae00a.svg";
export { ForwardRef as ReactComponent };